// extracted by mini-css-extract-plugin
module.exports = {"link":"SrPartnerTaskList--link--2UtfY","highlightYellowFadeIn":"SrPartnerTaskList--highlightYellowFadeIn--3Wjhn"};